type Severity = 'severe' | 'moderate' | 'low' | 'high' | 'medium' | 'critical' | 'minor' | 'clean' | 'none' | string;

const STYLES: Record<string, string> = {
  severe: 'bg-red-100 text-red-800 border-red-200',
  critical: 'bg-red-100 text-red-800 border-red-200',
  high: 'bg-red-100 text-red-800 border-red-200',
  moderate: 'bg-amber-100 text-amber-800 border-amber-200',
  medium: 'bg-amber-100 text-amber-800 border-amber-200',
  minor: 'bg-amber-100 text-amber-800 border-amber-200',
  low: 'bg-sky-100 text-sky-800 border-sky-200',
  clean: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  none: 'bg-emerald-100 text-emerald-800 border-emerald-200',
};

export function RiskBadge({ severity, label }: { severity: Severity; label?: string }): JSX.Element {
  const style = STYLES[severity.toLowerCase()] ?? 'bg-ink-100 text-ink-700 border-ink-200';
  return (
    <span className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide ${style}`}>
      {label ?? severity}
    </span>
  );
}
